import vars from './vars';

let intitBg = false;
let $activeBg;
let timer;

export default {
	show() {
		if (intitBg || innerWidth > 560) {
			return;
		}

		let num = Math.floor(Math.random() * 2);

		$activeBg = $(vars.$bg[num]);

		$activeBg.removeClass('is-hidden');

		timer = setInterval(() => {
			if (!intitBg || innerWidth > 560) {
				return;
			}

			let $nextBg = $activeBg.next();

			if ($activeBg.data('bg') === 1) {
				$nextBg = $(vars.$bg[0]);
			}

			new TimelineMax({
				onStart() {
					$nextBg.removeClass('is-hidden');
					$activeBg = $nextBg;
				},
			})
				.to($activeBg, 0.5, {
					autoAlpha: 0,
				}, 0)
				.fromTo($nextBg, 0.5, {
					autoAlpha: 0,
				}, {
					autoAlpha: 1,
					clearProps: 'all',
				}, 0);
		}, 4000);

		intitBg = true;
	},

	destroy() {
		clearInterval(timer);
		intitBg = false;
		vars.$bg.addClass('is-hidden');
		TweenMax.set(vars.$bg, {clearProps: 'all'});
	},
};
